import { iframeStep } from './iframeStep';
import { infoStep } from './infoStep';

export const foodstyle = {
  namespaced: true,
  modules: {
    iframeStep,
    infoStep
  }
};
